import { InfoCircleOutlined } from '@ant-design/icons'
import { Table } from 'antd'
import styled from 'styled-components'

export const ProjectsWrapper = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`

export const TitleText = styled.span`
  color: #0f2242;
  font-weight: 400;
`

export const TypeTagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
`

export const TooltipText = styled.span`
  font-size: 12px;
`

export const TooltipContent = styled.div`
  font-size: 12px;
`

export const TooltipSection = styled.div`
  margin-bottom: 8px;
`

export const TooltipSteps = styled.div`
  margin-left: 12px;
  margin-top: 4px;
`

export const HelpIcon = styled(InfoCircleOutlined)`
  cursor: help;
  font-size: 12px;
`

export const ArchivedHelpIcon = styled(InfoCircleOutlined)`
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
`

export const ArchiveActionLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`

export const ActionButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;

  &:hover {
    color: rgba(0, 0, 0, 0.88);
  }
`

export const StyledTable = styled(Table)`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;

  border: 1px solid #d8d8d8;
  border-radius: 8px;
  overflow: hidden;

  .ant-spin-nested-loading,
  .ant-spin-nested-loading > .ant-spin-container {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  .ant-table {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  .ant-table-container {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  .ant-table-body {
    flex: 1;
    min-height: 0;
    max-height: none !important;
  }

  .ant-pagination {
    flex-shrink: 0;
    margin-top: 12px;
  }

  .ant-table-cell {
    padding: 8px 16px;
  }

  .ant-table-thead > tr > th {
    background: #f2f6fd !important;
    color: #173663 !important;
    font-weight: 500 !important;
    z-index: 2;
  }

  .ant-table-thead > tr > th.ant-table-cell-fix-left {
    background: #f2f6fd !important;
    z-index: 3 !important;
  }

  .ant-table-tbody > .ant-table-row > td.ant-table-cell-fix-left {
    z-index: 1;
  }

  .ant-table-tbody > .ant-table-row > td,
  .ant-table-tbody > .ant-table-row > td.ant-table-cell-fix-left {
    background-color: #ffffff !important;
    border-bottom: 1px solid #f5f5f5;
    color: #0f2242;
    font-weight: 400;
  }

  .ant-table-tbody > .ant-table-row:hover > td,
  .ant-table-tbody > .ant-table-row:hover > td.ant-table-cell-fix-left {
    background-color: #f2f6fd !important;
  }

  .ant-table-tbody > .ant-table-row.is-clickable-row {
    cursor: pointer;
  }

  .ant-table-tbody > .ant-table-row.ant-table-row-selected > td,
  .ant-table-tbody
    > .ant-table-row.ant-table-row-selected
    > td.ant-table-cell-fix-left {
    background-color: #f2f6fd !important;
  }

  .ant-table-tbody > .ant-table-row.ant-table-row-selected:hover > td,
  .ant-table-tbody
    > .ant-table-row.ant-table-row-selected:hover
    > td.ant-table-cell-fix-left {
    background-color: #e3ecfb !important;
  }

  .ant-table-tbody > .ant-table-row.is-keyboard-focused > td,
  .ant-table-tbody
    > .ant-table-row.is-keyboard-focused
    > td.ant-table-cell-fix-left {
    background-color: #f2f6fd !important;
  }

  .ant-table-tbody > .ant-table-row:focus-visible > td,
  .ant-table-tbody > .ant-table-row.is-keyboard-focused > td {
    box-shadow:
      inset 0 2px 0 #1859af,
      inset 0 -2px 0 #1859af;
  }

  .ant-table-tbody > .ant-table-row:focus-visible > td:first-child,
  .ant-table-tbody > .ant-table-row.is-keyboard-focused > td:first-child {
    box-shadow:
      inset 0 2px 0 #1859af,
      inset 0 -2px 0 #1859af,
      inset 2px 0 0 #1859af;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }

  .ant-table-tbody > .ant-table-row:focus-visible > td:last-child,
  .ant-table-tbody > .ant-table-row.is-keyboard-focused > td:last-child {
    box-shadow:
      inset 0 2px 0 #1859af,
      inset 0 -2px 0 #1859af,
      inset -2px 0 0 #1859af;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #1859af !important;
    border-color: #1859af !important;
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: #ffffff !important;
    border-color: #1859af !important;
  }

  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    background-color: #1859af !important;
  }

  .ant-checkbox-checked::after,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #1859af !important;
  }

  .ant-table-sticky-holder {
    background: #f2f6fd !important;
  }
` as typeof Table
